var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-button',{attrs:{"block":"","type":_vm.buttontype},on:{"click":_vm.Save}},[_vm._v(_vm._s(_vm.buttonname))])}
var staticRenderFns = []

export { render, staticRenderFns }